export type MarkupServer = string;

export enum MarkupServerType {
  text = 'text',
  html = 'html'
}
